import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  const { payload } = action;
  switch (action.type) {
    case types.GET_SPOTLIGHT_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_SPOTLIGHT_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: payload.spotlight,
          count: payload.count,
          isLoaded: true,
        },
      };
    case types.GET_SPOTLIGHT_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: payload.error,
        },
      };
    case types.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};
